import Icon from './Icon';

const Search = (props) => (
  <Icon
    {...props}
    path="M68.433 64.9l-13.667-13.667c3.485-4.205 5.6-9.657 5.6-15.602 0-0.011 0-0.022 0-0.033v0.002c-0.019-13.671-11.096-24.748-24.765-24.767h-0.002c-13.678 0-24.767 11.088-24.767 24.767s11.088 24.767 24.767 24.767v0 0c0.009 0 0.020 0 0.032 0 5.945 0 11.396-2.115 15.643-5.633l-0.041 0.033 13.667 13.667c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0zM35.6 55.367c-10.908-0.012-19.746-8.857-19.746-19.767 0-5.453 2.208-10.391 5.779-13.967l-0 0c3.543-3.582 8.458-5.8 13.891-5.8 0.027 0 0.053 0 0.080 0h-0.004c10.917 0 19.767 8.85 19.767 19.767s-8.85 19.767-19.767 19.767v0z"
  />
);

export default Search;
